export default function Description({ description }) {
    if (!description) return null;

    return (
        <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{
                __html: description,
            }}
        />
    );
}
